import Content from "uxp-documentation/src/pages/uxp-api/reference-spectrum/Spectrum UXP Widgets/Typography/index.md";
import * as React from 'react';
export default {
  Content,
  React
};